export default "__VITE_ASSET__Dyhe5rbN__"